import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { SystemIcon } from '@monorepo/nova-icons';
import { Button, Stack, Typography } from '@monorepo/nova-ui';

interface SupportedSymbolsErrorProps {
  onRetry: () => void;
}

export const SupportedSymbolsError: FC<SupportedSymbolsErrorProps> = ({
  onRetry,
}) => {
  const { t } = useTranslation(['keyMetrics']);

  return (
    <Stack alignItems="center" justifyContent="center" minHeight={200} gap={2}>
      <SystemIcon iconName="WarningCircle" size={48} color="error" />
      <Typography variant="h6" color="error" align="center">
        {t('keyMetrics:supportedSymbols.errorTitle')}
      </Typography>
      <Typography variant="body2" align="center">
        {t('keyMetrics:supportedSymbols.errorMessage')}
      </Typography>
      <Button variant="outlined" onClick={onRetry}>
        {t('keyMetrics:supportedSymbols.retry')}
      </Button>
    </Stack>
  );
};
